export const poolBaseUrlV2 = '/pool-details-v2'
